import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { usersActions, usersActionsAsync } from "../actions/usersActions";
import { appActions } from "../actions/appActions";
import { Auth } from "aws-amplify";


export const resetPasswordEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(usersActionsAsync.resetPassword.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const { password, userId } = action.payload;
                const currentUser = state.users.user;
                async function resetPassword() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const updatedUser = await dependencies.usersApi.resetPassword({
                        apiGatewayUrl,
                        token,
                        userId,
                        password
                    });
                    observer.next(usersActionsAsync.resetPassword.success({ user: updatedUser }));
                    observer.next(appActions.setMessage({ message: "Reset successful", severity: "success"}));
                }
                resetPassword().catch(error => {
                    console.log(error);
                    observer.next(usersActionsAsync.resetPassword.failure({ error }));
                    observer.next(appActions.setMessage({ message: "Update failed, Please try again later", severity: "error"}))
                });
            });
        })
    );
}